const hashAddress = (addr: string): number => {
    let h = 0;
    for (let i = 2; i < addr.length; i++) {
        h = ((h << 5) - h + addr.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
};

type Props = {
    address: string;
    ensImage?: string | null;
    size: number;
};

export function PiggyAvatar({ address, ensImage, size }: Props) {
    if (ensImage) {
        return (
            <img
                src={ensImage}
                alt="ENS avatar"
                width={size}
                height={size}
                style={{ borderRadius: 999, objectFit: "cover" }}
                draggable={false}
            />
        );
    }
    const hue = hashAddress(address) % 360;
    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: 999,
                overflow: "hidden",
                background: "linear-gradient(135deg, #dfff52 0%, #8fb300 100%)",
                display: "grid",
                placeItems: "center",
                boxShadow: "0 0 14px rgba(204, 255, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.15)",
            }}
        >
            <img
                src="/piggy.png"
                alt="Safe Piggy"
                width={size}
                height={size}
                style={{
                    objectFit: "contain",
                    filter: `hue-rotate(${hue}deg)`,
                    display: "block",
                }}
                draggable={false}
            />
        </div>
    );
}
